// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cQ-z","twoColumnImage":"dQ-z"};